<ng-container *ngIf="!!page">
    <ng-container *ngIf="'mobile' | mediaQuery">
        <tt-card ttHeading="tt_heading_info" ttTranslateHeading ttAccordion>
            <ng-container *ngIf="showProductInfo">
                <ng-container *ngTemplateOutlet="info"></ng-container>
            </ng-container>
            <ng-container *ngTemplateOutlet="productImage"> </ng-container>
            <ng-container *ngIf="showAssemblyGroup">
                <ng-container *ngTemplateOutlet="assemblyGroup"></ng-container>
            </ng-container>
            <ng-container *ngIf="showButtonFunctions">
                <ng-container *ngTemplateOutlet="buttonFunctions"></ng-container>
            </ng-container>
        </tt-card>

        <tt-card ttHeading="tt_heading_structure" ttTranslateHeading ttAccordion>
            <ng-container *ngTemplateOutlet="treeView"></ng-container>
        </tt-card>

        <div class="tt-product-bom-content__data--mobile">
            <ng-container *ngTemplateOutlet="lists"></ng-container>
        </div>

        <tt-card *ngIf="page.show_setting === '1'">
            <tt-button-settings></tt-button-settings>
        </tt-card>
    </ng-container>

    <ng-container *ngIf="!('mobile' | mediaQuery)">
        <tt-divider [ttRememberId]="headerDividerRememberId">
            <tt-divider-rows>
                <tt-divider-pane ttSize="20">
                    <tt-divider-columns class="productbom_fields">
                        <tt-divider-pane *ngIf="showProductInfo">
                            <tt-card>
                                <ng-container *ngTemplateOutlet="info"></ng-container>
                            </tt-card>
                        </tt-divider-pane>

                        <tt-divider-pane>
                            <tt-card>
                                <ng-container *ngTemplateOutlet="productImage"> </ng-container>
                            </tt-card>
                        </tt-divider-pane>

                        <tt-divider-pane *ngIf="showAssemblyGroup">
                            <tt-card>
                                <ng-container *ngTemplateOutlet="assemblyGroup"></ng-container>
                            </tt-card>
                        </tt-divider-pane>

                        <tt-divider-pane *ngIf="showButtonFunctions">
                            <tt-card>
                                <ng-container *ngTemplateOutlet="buttonFunctions"></ng-container>
                            </tt-card>
                        </tt-divider-pane>
                    </tt-divider-columns>
                </tt-divider-pane>
                <tt-divider-pane ttSize="80">
                    <tt-divider-columns>
                        <tt-divider-pane ttSize="10">
                            <tt-card ttClass="productbom__tree-view-card">
                                <ng-container *ngTemplateOutlet="treeView"></ng-container>
                            </tt-card>
                        </tt-divider-pane>
                        <tt-divider-pane ttSize="90" class="tt-product-bom-content__data">
                            <ng-container *ngTemplateOutlet="lists"></ng-container>
                        </tt-divider-pane>
                    </tt-divider-columns>
                </tt-divider-pane>
            </tt-divider-rows>
        </tt-divider>

        <tt-card *ngIf="page.show_setting === '1'">
            <tt-button-settings></tt-button-settings>
        </tt-card>
    </ng-container>

    <ng-template #info>
        <tt-input ttLabel="prod_id_selected" [ttModel]="page.prod_id_selected" ttReadonly>
            <ng-container buttons>
                <tt-form-field-button ttIcon="far fa-chevron-right" ttGoto="product" [ttGotoParms]="{ prod_id: page.prod_keyno_selected }"></tt-form-field-button>
            </ng-container>
        </tt-input>
        <tt-input ttLabel="prod_name_selected" [ttModel]="page.prod_name_selected" ttReadonly></tt-input>
        <tt-select
            *ngIf="page.setting_use_productversion === '1'"
            [ttRememberId]="'w_productbom.' + page.prod_id + '.' + page.prod_id_selected + '.productversion_keyno'"
            ttLabel="productversion"
            [(ttModel)]="page.productversion_keyno"
            (ttModelChange)="onVersionChanged()"
            [ttData]="versions"
            ttDataId="productversion_keyno"
            ttDataName="version_description"
        ></tt-select>
    </ng-template>

    <ng-template #productImage>
        <tt-image ttLabel="picture" ttLabelView="top" [ttSrc]="productImageUrl" ttHeight="100px"></tt-image>
    </ng-template>

    <ng-template #treeView>
        <tt-tree-view
            *ngIf="productBomTree.length > 0"
            [ttRememberIdExpanded]="'w_productbom.treeview.nodes.' + page.prod_id"
            ttOnlyRememberExpanded="false"
            ttDataId="node_id"
            ttDataParentId="parent_node_id"
            [(ttSelectedId)]="selectedProductBomNodeId"
            (ttOnSelect)="onProductSelected($event)"
            [ttData]="productBomTree"
        ></tt-tree-view>
    </ng-template>

    <ng-template #assemblyGroup>
        <tt-list [ttData]="customKpis"></tt-list>
        <tt-select
            *ngIf="page.setting_show_assemblygroup_select_list === '1'"
            ttLabel="assemblygroup"
            [(ttModel)]="page.assemblygroup_no"
            (ttModelChange)="onAssemblyGroupChanged()"
            [ttData]="assemblyGroups"
            ttDataId="assemblygroup_id"
            ttDataName="assemblygroup_name"
        ></tt-select>
    </ng-template>

    <ng-template #buttonFunctions>
        <tt-button-goto *ngIf="page.show_button_move_choice === '1'" ttText="productbom_move_choice" ttGoto="productmovechoices" [ttGotoParms]="{ prod_id: params?.prod_id }"></tt-button-goto>
        <tt-button *ngIf="page.show_button_errorcheck === '1'" ttText="productbom_errorcheck" ttIcon="far fa-sync" [ttLoading]="errorCheckRunning" (ttClick)="runErrorCheck()"></tt-button>
    </ng-template>

    <ng-template #lists>
        <tt-tabs ttOnlyRemember="true" [ttRememberId]="'w_productbom.gb_productbom_list.' + page.prod_id" [(ttSelectedId)]="page.gb_productbom_list" (ttSelectedIdChange)="onTabChanged()">
            <tt-tab ttId="COMPONENT" ttLabel="gb_productbom_list_component"></tt-tab>
            <tt-tab ttId="WORK" ttLabel="gb_productbom_list_work"></tt-tab>
            <tt-tab ttId="OTHER" ttLabel="gb_productbom_list_other"></tt-tab>
            <tt-tab *ngIf="page.setting_use_productversion === '1'" ttId="VERSIONS" ttLabel="gb_productbom_list_versions"></tt-tab>
            <tt-tab ttId="DOCUMENTS" ttLabel="documents_documents"></tt-tab>
            <tt-tab ttId="PICTURES" ttLabel="documents_pictures"></tt-tab>
            <tt-tab ttId="VIDEOS" ttLabel="documents_videos"></tt-tab>
        </tt-tabs>

        <tt-grid [hidden]="page.gb_productbom_list !== 'COMPONENT'" *ngIf="!!componentsGrid" class="flex-1" [(ttOptions)]="componentsGrid"></tt-grid>

        <div [hidden]="page.gb_productbom_list !== 'WORK'" class="height-full flex-column flex-1" style="display: contents">
            <tt-grid *ngIf="!!operationsGrid" class="flex-1" [(ttOptions)]="operationsGrid"></tt-grid>
            <tt-card>
                <tt-button-goto
                    *ngIf="page.show_dataharvest === '1'"
                    ttText="productbom_dataharvest"
                    ttGoto="productdataharvest"
                    [ttGotoParms]="{ argtype: 'prod_id', argvalue: page.prod_keyno_selected }"
                ></tt-button-goto>
            </tt-card>
        </div>

        <ng-container *ngIf="page.setting_use_productversion === '1'">
            <tt-divider [hidden]="page.gb_productbom_list !== 'VERSIONS'" ttRemember="w_productbom.versions.divider">
                <tt-divider-rows>
                    <tt-divider-pane>
                        <tt-grid
                            *ngIf="!!productVersionsGrid"
                            [(ttOptions)]="productVersionsGrid"
                            ttRowSelection="single"
                            (ttOnRead)="onProductVersionsGridRead()"
                            (ttOnRowSelected)="onProductVersionSelected($event)"
                            (ttRowDataChange)="onProductVersionsDataChanged($event)"
                        ></tt-grid>
                    </tt-divider-pane>
                    <tt-divider-pane>
                        <tt-grid *ngIf="!!productVersionProdplaceGrid" [(ttOptions)]="productVersionProdplaceGrid"></tt-grid>
                    </tt-divider-pane>
                </tt-divider-rows>
            </tt-divider>
        </ng-container>

        <tt-toast *ngIf="showEmptyListToast" ttType="warning" ttTitle="list_is_empty"></tt-toast>

        <tt-list [hidden]="page.gb_productbom_list !== 'OTHER'" [ttData]="usedInProducts"></tt-list>
        <tt-list [hidden]="page.gb_productbom_list !== 'DOCUMENTS'" [ttData]="documents" ttShowFileExtensionIcon></tt-list>
        <tt-list [hidden]="page.gb_productbom_list !== 'PICTURES'" [ttData]="pictures" ttShowFileExtensionIcon></tt-list>
        <tt-list [hidden]="page.gb_productbom_list !== 'VIDEOS'" [ttData]="videos" ttShowFileExtensionIcon></tt-list>
    </ng-template>
</ng-container>

<!--<tt-page class="col-xs-12 sp-0">
    <tt-header ng-if="vm.model.setting.webpage_heading > ''" tt-model="vm.model.setting.webpage_heading"></tt-header>

    <div class="col-xs-12 sp-0 productbom__fields">
        <tt-card class="col-xs-12 col-md-3 p-5">
            <tt-input-buttons class="col-xs-12 sp-0" tt-label="prod_id_selected" tt-model="vm.model.setting.prod_id_selected" tt-change="vm.model.setting.prod_id_selected = $value" tt-placeholder="" tt-buttons="vm.model.productSelectedButtons" tt-readonly="true"></tt-input-buttons>
            <tt-input class="col-xs-12 sp-0" tt-label="prod_name_selected" tt-model="vm.model.setting.prod_name_selected" tt-change="vm.model.setting.prod_name_selected = $value" tt-readonly="true"></tt-input>
        </tt-card>

        <tt-card class="col-xs-12 col-md-3 p-5 productbom__fields__img" ng-if="vm.model.setting.productImageUrl > ''">
            <img ie-http-src="{{vm.model.setting.productImageUrl}}" ie-application-id="vm.model.applicationId" label="picture" class="img-thumbnail input-group" style="max-height: 400px; width: auto;" />
        </tt-card>

        <div class="col-xs-12 col-md-3 p-5">
            <im-list-directive class="col-xs-12 sp-0" list-items="vm.model.itemsListOwns" badge="" ltype="" design-var="s12t0"></im-list-directive>

            <tt-card class="col-xs-12 sp-0" ng-if="vm.model.setting.setting_show_assemblygroup_select_list === '1'">
                <tt-select class="col-xs-12 sp-0" tt-label="assemblygroup" tt-label-view="top" tt-model="vm.model.setting.assemblygroup_id" tt-change="vm.onChanged($value, 'assemblygroup_id')" tt-data="vm.model.selectListAssemblyGroups" tt-data-id="assemblygroup_id" tt-data-name="assemblygroup_name"></tt-select>
            </tt-card>
        </div>

        <tt-card class="col-xs-12 col-md-3 p-5" ng-if="vm.model.setting.show_button_move_choice === '1' || vm.model.setting.show_button_errorcheck === '1'">
            <tt-button-goto ng-if="vm.model.setting.show_button_move_choice === '1'" class="col-xs-12 sp-0" tt-text="productbom_move_choice" tt-goto="productmovechoices" tt-goto-parms="{ prod_id: vm.model.prodId }" tt-text-align="left"></tt-button-goto>
            <tt-button ng-if="vm.model.setting.show_button_errorcheck === '1'" class="col-xs-12 sp-0" tt-text="productbom_errorcheck" tt-click="vm.checkError()" tt-spin="vm.model.checkingError" tt-text-align="center" tt-type="primary" tt-icon="fas fa-sync-alt" tt-icon-align="center"></tt-button>
        </tt-card>
    </div>

    <div class="col-xs-12 sp-0">
        <im-tree-directive class="col-xs-12 p-5" list-items="vm.model.treeListProductBoms" mode="full" setup="vm.model.setting.prod_id_selected" optionfunc="vm.selectTreeItem(item)" auto-size="true">
            <tt-card class="col-xs-12 p-5">
                <tt-buttons-radio class="col-xs-12 sp-0" tt-buttons="vm.model.bgProductBomList.buttons" tt-model="vm.model.bgProductBomList.selected" tt-change="vm.selectBgProductBomList($value)"></tt-buttons-radio>
            </tt-card>

            <tt-grid ng-show="vm.model.bgProductBomList.selected === 'COMPONENT'" ng-if="vm.model.gridComponentsReady" class="col-xs-12 p-5" tt-options="vm.gridComponents"></tt-grid>
            <tt-grid ng-show="vm.model.bgProductBomList.selected === 'WORK'" ng-if="vm.model.gridOperationsReady" class="col-xs-12 p-5" tt-options="vm.gridOperations"></tt-grid>
            <tt-list ng-if="vm.model.bgProductBomList.selected === 'OTHER'" class="col-xs-12 p-5" list-items="vm.model.itemsListIncludedIn"></tt-list>
            <tt-list ng-if="vm.model.bgProductBomList.selected === 'DOCUMENTS'" class="col-xs-12 p-5" list-items="vm.model.itemsListDocuments" use-doc-icon="true"></tt-list>
            <tt-list ng-if="vm.model.bgProductBomList.selected === 'PICTURES'" class="col-xs-12 p-5" list-items="vm.model.itemsListPictures" use-doc-icon="true"></tt-list>
            <tt-list ng-if="vm.model.bgProductBomList.selected === 'VIDEOS'" class="col-xs-12 p-5" list-items="vm.model.itemsListVideos" use-doc-icon="true"></tt-list>

            <tt-card class="col-xs-12 p-5" ng-show="vm.model.bgProductBomList.selected === 'WORK'" ng-if="vm.model.setting.show_dataharvest === '1'">
                <tt-button-goto class="col-xs-12 sp-0" tt-text="productbom_dataharvest" tt-goto="productdataharvest" tt-goto-parms="{ argtype: 'prod_id', argvalue: vm.model.setting.prod_keyno_selected }" tt-text-align="left"></tt-button-goto>
            </tt-card>
        </im-tree-directive>

        <tt-card class="col-xs-12 p-5" ng-if="vm.model.setting.show_setting === '1'">
            <tt-button-settings class="col-xs-12 sp-0" tt-locked=""></tt-button-settings>
        </tt-card>
    </div>
</tt-page>
-->
